export class PositionMetricsGenerationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'PositionMetricsGenerationError'
  }
}
